module.exports = __webpack_public_path__ + "img/jcb.d79d691d.png";